import { BonusSettlementType } from '@synergy/models';
import { createSelector } from 'reselect';

import { AppState } from '../../../../store/store';
import { bonusSettlementsSupplierOverviewDetailsSelector } from '../../detail/supplier-overview/store/bonus-settlements-supplier-overview-selector';

export const bonusSettlementsState = (state: AppState) => state.bonusSettlements;

export const bonusSettlementCustomerDetailSidebarSelector = createSelector(
    bonusSettlementsState,
    bonusSettlementsSupplierOverviewDetailsSelector,
    (state, sup) => {
        if (!state.customerDetail.sidebarDetails) {
            return { details: undefined };
        }

        return {
            details: {
                ...state.customerDetail.sidebarDetails,
                type: sup?.type ?? BonusSettlementType.Main,
            },
        };
    }
);

export const bonusSettlementCustomerDetailSelector = createSelector(bonusSettlementsState, state => ({
    bonusSettlementCustomers: state.customerDetail.bonusSettlementCustomerDetail,
}));

export const bonusSettlementsCustomerDetailRequestingSelector = createSelector(
    bonusSettlementsState,
    state => state.customerDetail.requesting
);
